"use client";

import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import { FaArrowDown, FaChevronDown } from "react-icons/fa";

function ScrollButton({ className, target }) {
  return (
    <>
      <button
        className={twMerge(
          clsx(
            `border-dashed w-28 h-28 md:w-32 md:h-32 grid place-content-center rounded-full border border-palette-dark-3 z-0 hover:brightness-110 hover:scale-105 active:scale-95 transition-all duration-300 ease-in-out`,
            className,
          ),
        )}
        onClick={() => {
          window.scrollTo({
            top: document.querySelector(target).offsetTop,
            behavior: "smooth",
          });
        }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-8 md:w-10"
          viewBox="0 0 57 102"
          fill="none">
          <path
            id="Path"
            d="M28.5181 100.218L54.2067 74.5296L50.9946 71.3175L29.1753 93.1368L29.1771 2.26495L24.6487 2.26423L24.647 93.1361L4.42686 72.916L1.21578 76.127L25.3065 100.218C26.1935 101.105 27.6313 101.105 28.5181 100.218Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </>
  );
}

export default ScrollButton;
